<template>
  <div class="no-domain-page">
    <div class="container">
      <img class="logo" src="@/assets/omind_logo.png" alt="OMIND" />
      <h1>Welcome to the OMIND Platform</h1>
      <p>Please access the platform using your organization's workspace URL.</p>

      <div class="access-info">
        <h2>Example workspace URL</h2>
        <div class="url-example">your-company.{{ baseDomain }}</div>
        <p class="help-text">
          Contact your administrator if you don't know your workspace URL.
        </p>
      </div>

      <div class="contact-section">
        <p>Need help?</p>
        <a href="mailto:support@omind.ai" class="support-link">
          <font-awesome-icon icon="fa-solid fa-envelope" class="mr-2"/>
          support@omind.ai
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoDomainView',
  computed: {
    baseDomain() {
      const { hostname } = window.location;
      // Remove port for display purposes
      if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
        return 'localhost:8080';
      }
      // For production, show the actual domain
      return hostname;
    },
  },
};
</script>

<style scoped>
.no-domain-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fef7f0 0%, #fff5eb 100%);
  font-family: 'AsenPro', 'Segoe UI', system-ui, -apple-system, sans-serif;
  padding: 2rem;
}

.container {
  text-align: center;
  padding: 1.25rem;
  max-width: 36rem;
  width: 100%;
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 4px 24px rgba(228, 130, 26, 0.1);
  border: 1px solid rgba(228, 130, 26, 0.1);
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 1.5rem;
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1E2019;
}

p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.access-info {
  background: linear-gradient(
    135deg,
    rgba(200, 58, 119, 0.05),
    rgba(228, 75, 85, 0.05),
    rgba(228, 130, 26, 0.08)
  );
  border: 1px solid rgba(228, 130, 26, 0.2);
  border-radius: 1rem;
  padding: 1.5rem;
  margin-top: 1.5rem;
}

.access-info h2 {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
  margin-bottom: 0.75rem;
}

.url-example {
  display: inline-block;
  background: linear-gradient(135deg, #c83a77, #e44b55, #e4821a);
  color: white;
  padding: 0.625rem 1.25rem;
  border-radius: 2rem;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.9rem;
  font-weight: 500;
}

.help-text {
  margin-top: 1rem;
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 0;
}

.contact-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}

.contact-section p {
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 0.5rem;
}

.support-link {
  color: #e4821a;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.support-link:hover {
  color: #c83a77;
}
</style>
